import React, { useState } from "react";
// import '../styles/inbox.css';

// assets
import { Popover } from "antd";
import InboxFilter from "../../../../assets/customSVG/inbox/InboxFilter";
import OpenConversation from "../../../../assets/customSVG/inbox/OpenConversation";
import ClosedConversationIcon from "../../../../assets/customSVG/inbox/ClosedConversationIcon";
import InboxRemainderIcon from "../../../../assets/customSVG/inbox/InboxRemainderIcon";
import { ICONS } from "../../../../assets/icons";
import CheckBoxSqure from "../../../../components/commonComponents/checkbox/CheckBoxSqure";
import { cn } from "../../../../helper/cn";
import FilterComponent from "./FilterComponent";

const ConversationsType = ({
  loading,
  conversations,
  selectedConversationType,
  onConversationTypeChange,
  onFilterChange,
  selectedFilterType,
  activeTabName,
  phoneNumberCount,
  conversationUnreadData,
  clearType,
}) => {
  const conversationType = selectedConversationType
    ?.filter((item) => item?.isSelected === true)
    ?.map((item) => item.msg);

  const selectedFiltersType = selectedFilterType
    ?.filter((item) => item?.isSelected === true)
    ?.map((item) => item.msg);

  const shouldShowPopover = ![
    "All Conversations",
    "Unread",
    "Unassigned",
    "Resolved",
    "Favorited",
  ].includes(activeTabName);

  const isClearEnabled = selectedFiltersType?.length > 0;

  return (
    <div className="w-full max-h-[7.5vw] bg-[var(--white)] pt-10">
      <div className="w-100 flex-col align-center space-between border-[var(--border-50)]">
        <div className="flex flex-col">
          <div className="w-full max-w-md mx-auto">
            {/* Tabs */}
            <div className="flex w-full gap-2 text-[14px] border-b border-[var(--border-50)] mt-10">
              {conversations?.map((item, index) => (
                <ConversationTabButton
                  key={index}
                  item={item}
                  index={index}
                  total={conversations.length}
                  onClick={onConversationTypeChange}
                  conversationUnreadData={conversationUnreadData}
                />
              ))}
            </div>

            <div className="flex items-ceter mt-2 gap-2">
              <div className="flex bg-[#d8fdd2] flex-1 items-center text-[#05805c] text-xs px-2 py-2 rounded-md">
                <span>
                  <InboxRemainderIcon size={20} className="" />
                </span>
                <span className="px-2">
                  {loading
                    ? 0
                    : phoneNumberCount > 99
                    ? "99+"
                    : phoneNumberCount}
                </span>
                {conversationType}{" "}
                {phoneNumberCount < 2 ? "conversation" : "conversations"}
              </div>

              {shouldShowPopover && (
                <Popover
                  trigger="click"
                  content={
                    <FilterComponent
                      isClearEnabled={isClearEnabled}
                      selectedFilterType={selectedFilterType}
                      loading={loading}
                      onFilterChange={onFilterChange}
                      clearType={clearType}
                    />
                  }
                >
                  <div
                    className={cn(
                      "group/status flex items-center justify-end gap-2.5 rounded-[0.4vw] pointer",
                      selectedFiltersType?.length === 0 &&
                        "hover:bg-[var(--BG-25)]"
                    )}
                  >
                    {selectedFiltersType?.length === 0 ? (
                      <InboxFilter
                        color="var(--textBlack)"
                        size={34}
                        className="p-2 rounded"
                      />
                    ) : (
                      <InboxFilter
                        strokeColor="#6940F2"
                        className="bg-[#E7E0FD] p-2 rounded"
                        size={34}
                      />
                    )}
                  </div>
                </Popover>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function ConversationTabButton({
  item,
  index,
  total,
  onClick,
  conversationUnreadData,
}) {
  const isFirst = index === 0;
  const isLast = index === total - 1;
  const isMiddle = !isFirst && !isLast;

  let borderClass = "";
  if (isFirst) borderClass = "border-r";
  else if (isLast) borderClass = "border-l";
  else if (isMiddle) borderClass = "border-x";

  const selectedClasses = item.isSelected
    ? "bg-[#d8fdd2] border-b-2 border-b-[#05805c] border-x-[#d8fdd2] text-[#05805c]"
    : "border-b-2 border-b-transparent text-gray-500";

  return (
    <button
      key={index}
      className={`flex-1 text-center py-1 flex items-center justify-center gap-2 ${borderClass} ${selectedClasses}`}
      onClick={() => onClick(item)}
    >
      <span className="mr-2">
        {item.type === "open" && (
          <OpenConversation
            className="w-[16px]"
            color={item.isSelected ? "#05805c" : "#6B7280"}
          />
        )}
        {item.type === "closed" && (
          <ClosedConversationIcon
            className="w-[16px]"
            color={item.isSelected ? "#05805c" : "#6B7280"}
          />
        )}
      </span>
      {item.msg}
      <div className="bg-[#FF543E] inbox10px-600 px-2 py-0.9 b-radius">
        {item.type === "open" &&
          conversationUnreadData?.open_unread_count > 0 &&
          conversationUnreadData?.open_unread_count}
        {item.type === "closed" &&
          conversationUnreadData?.closed_unread_count > 0 &&
          conversationUnreadData?.closed_unread_count}
      </div>
    </button>
  );
}

export default ConversationsType;
